<div class="flex h-screen-safe overflow-hidden">
  <div class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
    <div
      class="h-11 shrink-0 grid-cols-3 items-center gap-3 px-4 py-3 sm:gap-x-6 lg:flex"
      [ngClass]="hideSidebar() ? (minimalHeader() ? 'grid' : 'hidden') : 'grid'">
      @if (hideSidebar() && minimalHeader()) {
        <div class="flex items-center justify-self-start lg:flex-1">
          @if (headerBack(); as back) {
            <button type="button" (click)="back.action()" class="btn-hyperlink">
              <iconify-icon icon="solar:alt-arrow-left-outline" class="iconify-inline text-base"></iconify-icon>
              {{ back.label() }}
            </button>
          }
        </div>
        <div class="flex min-w-0 items-center justify-center gap-2 justify-self-center">
          <img [src]="(logo() | async) || '/logo.svg'" alt="GoCompetent" class="max-h-6 w-full object-contain" />
        </div>
        <div class="lg:flex-1"></div>
      } @else {
        <div class="flex min-w-0 items-center gap-x-3 justify-self-start lg:flex-1">
          <div class="flex min-w-0 shrink-0 items-center gap-3">
            <button type="button" command="show-modal" commandfor="sidebar"
              class="flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-full text-casper-900 hover-effect-elevate lg:hidden">
              <span class="sr-only">Open sidebar</span>
              <iconify-icon icon="solar:hamburger-menu-outline" class="iconify-inline size-10"></iconify-icon>
            </button>

            <div class="hidden min-w-0 items-center gap-2 lg:flex">
              <img [src]="(logo() | async) || '/logo.svg'" alt="GoCompetent" class="max-h-6 w-full object-contain" />
              <span class="hidden text-sm font-normal text-tompoes-pink-600 sm:block">GoCompetent</span>
            </div>
          </div>

          @if (canSelectSector()) {
          <div class="flex items-center gap-x-4">
            <div class="hidden min-w-40 lg:block">
              <ng-container *ngTemplateOutlet="sectorSelect; context: { selectId: 'sector-select' }"></ng-container>
            </div>
          </div>
          }

        </div>

        <div class="flex min-w-0 items-center justify-center gap-2 justify-self-center lg:hidden">
          <img [src]="(logo() | async) || '/logo.svg'" alt="GoCompetent" class="max-h-6 w-full object-contain" />
          <span class="hidden text-sm font-normal text-tompoes-pink-600 sm:block">GoCompetent</span>
        </div>

        <div class="flex justify-end gap-x-4 justify-self-end self-stretch lg:flex-1 lg:gap-x-6">
          <div class="flex items-center gap-x-4 lg:gap-x-6">
            @if (canViewNotifications()) {
            <el-dropdown class="relative">
              <button type="button"
                class="relative hover-effect-elevate flex size-10 items-center justify-center rounded-full text-neutral-grey-700">
                <span class="sr-only">Meldingen bekijken</span>
                <iconify-icon icon="solar:bell-outline" class="iconify-inline text-xl"></iconify-icon>

                @if (unreadNotifications() > 0) {
                <span class="absolute right-2 top-2 size-2 rounded-full bg-primary ring-2 ring-neutral-grey-pure-white"></span>
                }
              </button>

              <el-menu anchor="bottom end" popover
                class="mt-3 origin-top-right rounded-3xl bg-transparent p-0 shadow-none outline-none transition transition-discrete data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-150 data-enter:ease-out data-leave:duration-100 data-leave:ease-in">
                <app-notifications-overview class="block sm:w-96"
                  (unreadNotifications)="unreadNotifications.set($event)"></app-notifications-overview>
              </el-menu>
            </el-dropdown>
            }

            <el-dropdown class="relative">
              <button
                class="relative flex max-w-48 items-center gap-2 cursor-pointer rounded-full py-1 pl-1 pr-3 hover-effect-elevate">
                <span class="absolute -inset-1.5"></span>
                <span class="sr-only">Open user menu</span>
                <app-avatar class="sm:hidden" size="md" [name]="currentUserService.displayName()"
                  [fallback]="currentUserService.initials() || '?'"></app-avatar>
                <app-avatar class="hidden sm:block" size="sm" [name]="currentUserService.displayName()"
                  [fallback]="currentUserService.initials() || '?'"></app-avatar>
                <span class="hidden min-w-0 max-w-28 truncate text-sm font-medium text-neutral-grey-950 sm:block">
                  {{ currentUserService.displayName() }}
                </span>
              </button>

              <el-menu anchor="bottom end" popover
                class="mt-2 w-32 origin-top-right rounded-md bg-neutral-grey-pure-white py-2 shadow-lg outline-1 outline-neutral-grey-950/5 transition transition-discrete data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in">
                @if (canOpenProfileModal()) {
                <a (click)="openProfileModal($event)"
                  class="cursor-pointer px-3 py-1 text-sm/6 text-neutral-grey-950 focus:bg-neutral-grey-50 focus:outline-hidden">
                  Mijn profiel
                </a>
                }

                <a class="cursor-pointer block px-3 py-1 text-sm/6 text-neutral-grey-950 focus:bg-neutral-grey-50 focus:outline-hidden"
                  (click)="logout()">
                  Uitloggen
                </a>
              </el-menu>
            </el-dropdown>
          </div>
        </div>
      }
    </div>

    <div class="flex min-h-0 flex-1 overflow-hidden">
      <aside class="shrink-0 px-4 py-2"
        [ngClass]="hideSidebar() ? 'hidden' : 'hidden lg:flex items-start justify-center'">
        <div
          class="group/sidebar flex h-full w-20 flex-col overflow-y-auto overflow-x-hidden rounded-xl bg-neutral-grey-pure-white/70 px-3 py-3 shadow-2xl backdrop-blur transition-all duration-300 ease-in-out hover:w-56">
          <ng-container *ngTemplateOutlet="navList"></ng-container>
        </div>
      </aside>

      <main class="flex min-h-0 flex-1 flex-col overflow-y-auto px-4 py-2">
        <ng-content></ng-content>
      </main>
    </div>
  </div>

  @if (slidePanelSlot.template(); as slidePanelTemplate) {
  <ng-container [ngTemplateOutlet]="slidePanelTemplate"></ng-container>
  }
</div>

<!-- Mobile sidebar -->
<el-dialog [ngClass]="hideSidebar() ? 'hidden' : 'block'">
  <dialog id="sidebar" class="backdrop:bg-transparent lg:hidden">
    <el-dialog-backdrop
      class="fixed inset-0 bg-casper-950/80 transition-opacity duration-300 ease-linear data-closed:opacity-0"></el-dialog-backdrop>

    <div tabindex="0" class="fixed inset-0 flex focus:outline-none">
      <el-dialog-panel
        class="group/dialog-panel relative flex w-full flex-1 transform transition duration-300 ease-in-out data-closed:-translate-x-full">

        <div class="relative flex grow flex-col overflow-hidden bg-neutral-grey-pure-white/95 shadow-2xl backdrop-blur-lg">

          <!-- Header -->
          <div class="flex shrink-0 items-center justify-between border-b border-neutral-grey-100 px-5 py-4">
            <div class="flex min-w-0 items-center gap-2">
              <img [src]="(logo() | async) || '/logo.svg'" alt="GoCompetent" class="max-h-8 w-auto object-contain" />
              <span class="text-sm font-semibold text-tompoes-pink-600">GoCompetent</span>
            </div>
            <button type="button" command="close" commandfor="sidebar"
              class="group/close flex size-9 cursor-pointer items-center justify-center rounded-full text-neutral-grey-500 transition-colors hover:bg-neutral-grey-100 hover:text-neutral-grey-950">
              <span class="sr-only">Sluiten</span>
              <iconify-icon icon="heroicons:x-mark"
                class="iconify-inline size-5 transition-transform duration-200 ease-out group-hover/close:rotate-90"></iconify-icon>
            </button>
          </div>

          <!-- Selects -->
          @if (canSelectSector()) {
          <div class="flex shrink-0 flex-col gap-2 border-b border-neutral-grey-100/80 px-4 py-3">
            <ng-container
              *ngTemplateOutlet="sectorSelect; context: { selectId: 'mobile-sector-select' }"></ng-container>
          </div>
          }

          <!-- Nav -->
          <div class="flex flex-1 flex-col overflow-y-auto px-4 py-3">
            <ng-container *ngTemplateOutlet="navList"></ng-container>
          </div>

        </div>
      </el-dialog-panel>
    </div>
  </dialog>
</el-dialog>

<!-- Profile modal -->
@if (showProfileModal()) {
<div class="fixed inset-0 z-50 flex items-stretch justify-center bg-neutral-grey-950/40 p-4">
  <div class="relative w-full max-w-5xl rounded-2xl bg-neutral-grey-pure-white shadow-2xl flex flex-col h-full overflow-hidden">
    <button type="button" (click)="closeProfileModal()"
      class="absolute right-3 top-3 text-neutral-grey-700 hover:text-neutral-grey-950">
      <iconify-icon icon="solar:close-circle-outline" class="iconify-inline size-6"></iconify-icon>
      <span class="sr-only">Sluiten</span>
    </button>

    <div class="flex-1 overflow-y-auto">
      <app-user-profile-management></app-user-profile-management>
    </div>
  </div>
</div>
}

<!-- Shared templates -->
<ng-template #navList>
  <nav class="flex flex-1 flex-col">
    <ul role="list" class="flex flex-1 flex-col gap-y-1">
      @for (route of visibleRoutes; track getRouteKey(route)) {
      <li>
        @let activeRoute = isRouteActive(route);

        <button type="button" (click)="onRouteClick(route, $event)" (mouseenter)="setHoveredRoute(getRouteKey(route))"
          (mouseleave)="setHoveredRoute()" [attr.aria-current]="activeRoute ? 'page' : null"
          [ngClass]="activeRoute ? 'lg:group-hover/sidebar:bg-primary lg:group-hover/sidebar:text-white' : 'lg:group-hover/sidebar:hover:bg-neutral-grey-pure-white/60'"
          class="select-none group flex w-full cursor-pointer items-center rounded-md text-casper-950 transition-all duration-200 ease-in-out
                 flex-row gap-3 px-2 py-2
                 lg:flex-col lg:gap-1.5 lg:px-0 lg:py-1.5
                 lg:group-hover/sidebar:flex-row lg:group-hover/sidebar:gap-2 lg:group-hover/sidebar:py-1 lg:group-hover/sidebar:pl-0 lg:group-hover/sidebar:pr-2">
          <span class="relative grid size-8 shrink-0 place-items-center rounded-md transition-colors duration-200 ease-out"
            [ngClass]="activeRoute ? 'bg-primary text-white shadow-sm lg:group-hover/sidebar:bg-transparent lg:group-hover/sidebar:shadow-none' : 'text-casper-950 group-hover:bg-neutral-grey-pure-white/60 lg:group-hover/sidebar:group-hover:bg-transparent'">
            <iconify-icon
              class="iconify-inline text-current text-base transition-transform duration-200 ease-out group-hover:scale-110"
              [attr.icon]="getRouteIcon(route, activeRoute)"></iconify-icon>
          </span>
          <span class="min-w-0 font-medium leading-none
                       text-sm
                       lg:w-full lg:truncate lg:text-center lg:text-xs
                       lg:group-hover/sidebar:flex-1 lg:group-hover/sidebar:text-left lg:group-hover/sidebar:text-xs">
            {{ route.title }}
          </span>
        </button>
      </li>
      }
    </ul>
  </nav>
</ng-template>

<ng-template #sectorSelect let-selectId="selectId">
  <label class="sr-only" [attr.for]="selectId">Sector</label>

  <el-dropdown class="relative block w-full">
    <button type="button" [id]="selectId" class="btn-secondary-outline max-w-full min-w-0 w-full hover-effect-elevate">
      <span class="flex w-full gap-2 pr-6">
        <span aria-hidden="true" class="inline-block size-2 shrink-0 rounded-full self-center"
          [style.background-color]="selectedSectorColor()"></span>
        <span class="truncate">{{ selectedSectorName || 'Selecteer sector' }}</span>
      </span>

      <iconify-icon icon="solar:alt-arrow-down-outline"
        class="iconify-inline size-5 col-start-1 row-start-1 self-center justify-self-end text-neutral-grey-700 sm:size-4"></iconify-icon>
    </button>

    <el-menu anchor="bottom start" popover
      class="mt-4 sm:mt-2 max-h-60 min-w-60 max-w-lg origin-top-left overflow-auto rounded-sm bg-neutral-grey-pure-white shadow-xl ring-1 ring-neutral-grey-200 transition transition-discrete duration-100 ease-out data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-leave:duration-75 data-leave:ease-in">
      <div class="t-small select-none border-b border-neutral-grey-200 p-3 text-neutral-grey-700">
        Wissel sector
      </div>
      <div class="flex flex-col gap-1 p-3">
      @for (sector of sectors; track sector.id) {
      <button type="button" class="t-small flex items-center justify-between gap-3 rounded-sm px-3 py-2 text-left"
        [ngClass]="selectedSectorId() === sector.id ? 'bg-primary/10 text-primary' : 'text-neutral-grey-700 hover:bg-neutral-grey-50'"
        [attr.aria-selected]="selectedSectorId() === sector.id ? 'true' : null"
        (click)="onSelectSector(sector.id)">
        <div class="flex min-w-0 items-center gap-2">
          <span aria-hidden="true" class="inline-block size-2 shrink-0 rounded-full"
            [style.background-color]="sector.primaryColor"></span>
          <span class="whitespace-normal break-words">
            {{ sector.name }}
          </span>
        </div>

        @if (selectedSectorId() === sector.id) {
        <iconify-icon icon="meteor-icons:check-double"
          class="iconify-inline size-4 shrink-0 text-primary brightness-75"></iconify-icon>
        }
      </button>
      }
      </div>
      </el-menu>
      </el-dropdown>
</ng-template>
